// Runtime UI translator: swaps hardcoded interface strings using /locales/{lang}.json.
const ATTRS = ["placeholder", "title", "aria-label"];
const SKIP = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "CODE", "PRE"]);
const nodes = new WeakMap(); // text node -> { src, applied }
const cache = {};
let dict = {};
let observer = null;

const norm = (s) => s.replace(/\s+/g, " ").trim();
const skipEl = (el) => !el || SKIP.has(el.tagName) || el.isContentEditable || !!el.closest("[data-no-translate]");

const translateText = (node) => {
  const cur = node.nodeValue;
  const rec = nodes.get(node);
  const src = rec && cur === rec.applied ? rec.src : cur;
  const key = norm(src);
  if (!key) return;
  const tr = dict[key];
  const out = tr ? src.match(/^\s*/)[0] + tr + src.match(/\s*$/)[0] : src;
  if (out !== cur) node.nodeValue = out;
  if (out !== src) nodes.set(node, { src, applied: out }); else nodes.delete(node);
};

const translateAttrs = (el) => {
  ATTRS.forEach((a) => {
    if (!el.hasAttribute(a)) return;
    const store = `data-i18n-${a}`;
    const cur = el.getAttribute(a);
    let src = el.getAttribute(store);
    if (src === null || cur !== el.getAttribute(`${store}-applied`)) src = cur;
    const out = dict[norm(src)] || src;
    el.setAttribute(store, src);
    el.setAttribute(`${store}-applied`, out);
    if (out !== cur) el.setAttribute(a, out);
  });
};

const walk = (root) => {
  if (root.nodeType === 3) { if (!skipEl(root.parentElement)) translateText(root); return; }
  if (root.nodeType !== 1 || skipEl(root)) return;
  translateAttrs(root);
  root.querySelectorAll("[placeholder],[title],[aria-label]").forEach((el) => { if (!skipEl(el)) translateAttrs(el); });
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (w.nextNode()) { if (!skipEl(w.currentNode.parentElement)) translateText(w.currentNode); }
};

const onMutations = (muts) => {
  muts.forEach((m) => {
    if (m.type === "characterData") { if (!skipEl(m.target.parentElement)) translateText(m.target); }
    else if (m.type === "attributes") { if (!skipEl(m.target)) translateAttrs(m.target); }
    else m.addedNodes.forEach(walk);
  });
};

const load = async (lang) => {
  if (!cache[lang]) {
    try { cache[lang] = await (await fetch(`/locales/${lang}.json`)).json(); } catch (e) { cache[lang] = {}; }
  }
  return cache[lang];
};

export const setDomLanguage = async (lang) => {
  dict = await load(lang);
  if (!observer) {
    observer = new MutationObserver(onMutations);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  walk(document.body);
};
